'use client'
import cn from "clsx";
import LeadFormWrapper from "@/revamp/organisms/LeadForm";
import FaqWithCategory from "@/revamp/organisms/FaqWithCategory";
import styles from "./FaqSection.module.scss";
import LpStudentTestimonial from "@/components/templates/LpStudentTestimonial";
import { OTPContext, OTPContextProvider, OTPContextWrapper } from "@/components/sections/CommonModals/context";
import FaqLandingForm from "@/LpRevamp/FaqLandingForm/FaqLandingform";
 
interface FaqWithFormProps {
  Faqs: any;
  associatedPrograms: any;
  isLambdaAPI?: boolean;
  testimonials?: any;
  isSpecificPage?:boolean;
  isRFIDisabled?: boolean
  isMbaLp?:boolean
  isProgramPage?:boolean
}

const FaqWithForm: React.FC<FaqWithFormProps> = ({ isProgramPage, Faqs, associatedPrograms, isLambdaAPI,testimonials,isSpecificPage=false, isRFIDisabled = false,isMbaLp=false }) => {
  return (
    <>
      <section className={styles.container}>
      <div className={`${isSpecificPage?styles.layoutSpecific:styles.layout} ${isLambdaAPI?styles.lpLayout:styles.layout} ${isRFIDisabled && styles.layoutRFIDisabled}`}>
          <div className={styles["faq-section"]}>
            {/* FAQ Section */}
            {Faqs && <FaqWithCategory {...Faqs} />}
          </div>
          {isLambdaAPI ? (
            <div>
              <LpStudentTestimonial isLandingPage={isLambdaAPI} testimonials={testimonials} isSpecificPage={isSpecificPage}  />
            </div>) : !isRFIDisabled ? 
           <div className={styles["lead-form-section"]}>
           {/* Lead Form Section */}
           <div className={cn("form-wrapper sm:mt-[15px]", styles.formSection)}>
            {
              isMbaLp?
              <OTPContextProvider isLambdaAPI={true}>
              <OTPContext.Consumer>
                {({ isHeaderHidden }) => (
                  <>
                  <OTPContextWrapper  isDarkForm={true} isLambdaAPI={true}>
                   <FaqLandingForm associatedPrograms={associatedPrograms} />
                  </OTPContextWrapper>
                  </>
                 )}
              </OTPContext.Consumer>
              </OTPContextProvider>
              :
              <LeadFormWrapper isProgramPage={isProgramPage} isSpecificPage={isSpecificPage} isLambdaAPI={isLambdaAPI} associatedPrograms={associatedPrograms} isFAQ />
            }
           </div>
         </div> : null
          }
        </div>
      </section>
    </>
  );
};

export default FaqWithForm;
